import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./components/pages/Home";
import Dashboard from "./components/pages/Dashboard2";
import Import from "./components/pages/Import";
import Chamada from "./components/pages/Chamada";
import Registada from "./components/pages/Registada";
import RChamada from "./components/pages/RChamada";
import Chamadapdf from "./components/pages/Chamadapdf";
import ChamadaExcel from "./components/pages/ChamadaExcel";
import Agente from "./components/pages/Agente";
import User from "./components/pages/User";
import RelatorioPDF from "./components/pages/RelatorioPDF";
import WhatsApp from "./components/pages/WhatsApp";

 

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Rota de login fora da estrutura protegida */}
        <Route path="/" element={<Login />} />
        <Route path="/pdf" element={<RelatorioPDF />} />
        <Route path="/import" element={<Import />} />
         <Route path="/chamadas_pdf" element={<Chamadapdf />} />
         <Route path="/chamadas-excel" element={<ChamadaExcel />} />
        <Route path="/chamads-movicel" element={<RChamada />} />
 
        {/* Rotas protegidas dentro de Home */}
        <Route
          path="/*"
          element={
          //  <Home />
          
           <ProtectedRoute>
            <Home />
            </ProtectedRoute>
 

          }
        >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="agentes" element={<Agente />} />
        <Route path="usuarios" element={<User />} />
        <Route path="chamadas" element={<Chamada />} />
        <Route path="registadas" element={<Registada />} />
        <Route path="whatsapp" element={<WhatsApp />} />
      
           
        </Route>
      </Routes>
    </Router>
  );
};

export default App;

